import {  downloadFile } from '@/framework/router/axios'
import { Quill } from 'vue-quill-editor'
var Link = Quill.import('formats/link')
class FileBlot extends Link { // 继承Link Blot
  static create(value) {  
    let node = undefined
    if (value && !value.href) { // 适应原本的Link Blot
      node = super.create(value); 
      let fileName = value.substring(0, value.lastIndexOf('&'))
      let fileCode = value.substring(value.lastIndexOf('&') + 1)
      let params = {}
      params.fileName = fileName
      params.fileCode = fileCode
      params.flag = true
      node.setAttribute('onclick', `window.fileDownLoad(${JSON.stringify(params)});return false;`);  // 左键点击即下载 
      // node.setAttribute('download', value.innerText);  // 左键点击即下载 
       
    } else { // 自定义Link Blot
      node = super.create(value.href );  
      node.setAttribute('onclick', `window.fileDownLoad(${JSON.stringify(value)});return false;`); 
      node.setAttribute('download', value.innerText);  // 左键点击即下载  
      node.innerText = value.innerText; 
    }
    return node;
  }
}
FileBlot.blotName = 'link';
FileBlot.tagName = 'A';
Quill.register(FileBlot);


// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{
    'header': 1
  }, {
    'header': 2
  }], // custom button values
  [{
    'list': 'ordered'
  }, {
    'list': 'bullet'
  }],
  [{
    'script': 'sub'
  }, {
    'script': 'super'
  }], // superscript/subscript
  [{
    'indent': '-1'
  }, {
    'indent': '+1'
  }], // outdent/indent
  [{
    'direction': 'rtl'
  }], // text direction

  [{
    'size': ['small', false, 'large', 'huge']
  }], // custom dropdown
  [{
    'header': [1, 2, 3, 4, 5, 6, false]
  }],

  [{
    'color': []
  }, {
    'background': []
  }], // dropdown with defaults from theme
  [{
    'font': []
  }],
  [{
    'align': []
  }],
  ['link', 'image', 'upload'],
  ['clean'] // remove formatting button
]
const titleConfig = {
  'ql-bold': '加粗',
  'ql-color': '颜色',
  'ql-font': '字体',
  'ql-code': '插入代码',
  'ql-italic': '斜体',
  'ql-link': '添加链接',
  'ql-background': '背景颜色',
  'ql-size': '字体大小',
  'ql-strike': '删除线',
  'ql-script': '上标/下标',
  'ql-underline': '下划线',
  'ql-blockquote': '引用',
  'ql-header': '标题',
  'ql-indent': '缩进',
  'ql-list': '列表',
  'ql-align': '文本对齐',
  'ql-direction': '文本方向',
  'ql-code-block': '代码块',
  'ql-formula': '公式',
  'ql-image': '图片',
  'ql-video': '视频',
  'ql-clean': '清除字体样式',
  'ql-upload': '文件'
}
export { titleConfig, toolbarOptions }